/* eslint-disable */
import React from 'react';
import ReactModal from 'react-modal';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { CustomCheckBox, RegularButton, CommonDropdown, AlertAdapter } from 'pg-ui-library';
import {
  ModalContent,
  Header,
  AllContent,
  MainContent,
  StatusContainer,
  StatusLabel,
  Footer,
  ModuleContainer,
  ModuleItem,
  UserDetailsGrid,
  CheckboxHeading,
  ModuleItemLabel,
} from './styles';

// 👉 replace with your CREATE mutation
import { useCreateExternalClientUser } from '../../mutations/external-user.mutation';

export const activeOptions = [
  { key: 'true', label: 'Active', value: 'true' },
  { key: 'false', label: 'Inactive', value: 'false' },
];

export const AddExternalClientUserModal: React.FC<{
  isOpen: boolean;
  onRequestClose: () => void;
  onSuccess?: () => void;
}> = ({ isOpen, onRequestClose, onSuccess }) => {
  const createClientUser = useCreateExternalClientUser();

  const formik = useFormik({
    initialValues: {
      email: '',
      username: '',
      firstName: '',
      middleName: '',
      lastName: '',
      isActive: 'true',
      permission: {
        invoice: true,
        expense: true,
        timesheet: false,
      },
    },
    validationSchema: yup.object({
      email: yup.string().email().required(),
      username: yup.string().required(),
      firstName: yup.string().required(),
      lastName: yup.string().required(),
    }),
    onSubmit: async values => {
      const payload = {
        ...values,
        isActive: values.isActive === 'true',
      };

      try {
        console.log('payload', payload);
        await createClientUser.mutateAsync(payload);
        AlertAdapter('User created successfully', 'success');
        onRequestClose();
        onSuccess?.();
      } catch (error: any) {
        AlertAdapter(error?.toString() || 'Something went wrong', 'error');
      }
    },
  });

  return (
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={onRequestClose}
      style={{
        overlay: {
          backgroundColor: 'rgba(0,0,0,0.6)',
        },
        content: {
          borderRadius: '30px',
          width: '760px',
          height: '550px',
          margin: 'auto',
          padding: '0',
          background: '#F3F4F8',
        },
      }}
    >
      <ModalContent>
        <Header>
          <h3>Add External Client User</h3>
        </Header>

        <AllContent>
          <MainContent>
            {/* BASIC INFO */}
            {/* <div style={{ display: 'grid', gap: 12 }}> */}
            <UserDetailsGrid>
              <input placeholder="Email" name="email" value={formik.values.email} onChange={formik.handleChange} />
              <input
                placeholder="Username"
                name="username"
                value={formik.values.username}
                onChange={formik.handleChange}
              />
              <input
                placeholder="First Name"
                name="firstName"
                value={formik.values.firstName}
                onChange={formik.handleChange}
              />
              <input
                placeholder="Middle Name"
                name="middleName"
                value={formik.values.middleName}
                onChange={formik.handleChange}
              />
              <input
                placeholder="Last Name"
                name="lastName"
                value={formik.values.lastName}
                onChange={formik.handleChange}
              />
            </UserDetailsGrid>
            {/* </div> */}

            {/* PERMISSIONS */}
            <ModuleContainer>
              <ModuleItemLabel>Permissions</ModuleItemLabel>

              {Object.keys(formik.values.permission).map(key => (
                <ModuleItem key={key}>
                  <CustomCheckBox
                    id={key}
                    label=""
                    checked={formik.values.permission[key as keyof typeof formik.values.permission]}
                    onChange={() =>
                      formik.setFieldValue(
                        `permission.${key}`,
                        !formik.values.permission[key as keyof typeof formik.values.permission]
                      )
                    }
                  />

                  <CheckboxHeading>{key.replace('_', ' ').toUpperCase()}</CheckboxHeading>
                </ModuleItem>
              ))}
            </ModuleContainer>

            {/* STATUS */}
          </MainContent>

          <Footer>
            <RegularButton type="button" onClick={onRequestClose} style={{ background: '#fff', color: '#4948AC' }}>
              Cancel
            </RegularButton>
            <RegularButton
              type="submit"
              onClick={() => formik.handleSubmit()}
              disabled={!formik.isValid || formik.isSubmitting}
            >
              Save
            </RegularButton>
          </Footer>
        </AllContent>
      </ModalContent>
    </ReactModal>
  );
};
